<script>
  import { beforeUpdate } from 'svelte';

  import { useNavigate } from 'svelte-navigator';
  import { authStore } from '../stores/General';
  import { checkAuth, loginWithPopup } from '../utils/auth';

  const { isAuthenticated } = authStore;
  const navigate = useNavigate();

  beforeUpdate(() => {
    if (!isAuthenticated) {
      checkAuth();
    }
  });

  $: onChangeAuth($isAuthenticated);

  function onChangeAuth(isAuthenticated) {
    if (isAuthenticated) {
      navigate('/', { replace: true });
      return;
    }
  }

  function handleLogin() {
    loginWithPopup();
  }
  // loginWithPopup();
</script>

<!--
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ]
  }
  ```
-->
<div class="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img class="mx-auto h-24 w-auto" src="/assets/logo/logo_symbol.png" alt="origin media logo" />
  </div>

  <!-- <div class="mt-4 mx-auto sm:w-full sm:max-w-md"> -->
  <h2 class="pt-6 mb-1 text-center text-l text-gray-700 outline-none">
    Origin Media Console Sign In
  </h2>
  <button
    type="button"
    on:click={handleLogin}
    class="mx-auto w-64 flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm
      text-xs font-medium text-white bg-custom-orange hover:bg-black focus:outline-none focus:ring-2
      focus:ring-offset-2"
  >
    Sign in
  </button>
  <!-- </div> -->
</div>
